/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { Link, Typography2 } from '@coursera/cds-core';
import { EmailIcon } from '@coursera/cds-icons';

import { getSubmitterEmail } from 'bundles/grading/utils/submissionUtils';

import CuiClockBlue from 'images/grading/cui-clock-blue.svg';

import _t from 'i18n!nls/grading';

import { SGAPageContext } from '../SGAPageContext';

const styles = {
  verticalLayout: css`
    display: flex;
    flex-direction: column;
    height: 100%;
  `,
  main: css`
    padding: var(--cds-spacing-200);

    /* 'bottom' container takes as much height as it needs, 'main' takes the rest */
    flex-grow: 1;

    /* vertically align nested 'mainInner' block: */
    display: flex;
    align-items: center;
  `,
  mainInner: css`
    margin: 0 auto;
    text-align: center;

    h3 {
      margin: var(--cds-spacing-300) 0 var(--cds-spacing-400) 0;
    }

    a > svg {
      margin-right: var(--cds-spacing-100);
    }

    a > * {
      vertical-align: middle;
    }
  `,
};

// No Submission View
const NoSubmission = () => {
  const { submissionData } = useContext(SGAPageContext);

  if (!submissionData.data?.submitter) {
    return null;
  }
  // when emails are not available, don't render the email link
  // use case: for anonymous submitters
  const mailToEmails = getSubmitterEmail(submissionData.data.submitter);

  return (
    <div css={styles.verticalLayout}>
      <div css={styles.main}>
        <div css={styles.mainInner}>
          <img src={CuiClockBlue} alt={_t('blue clock illustration')} aria-hidden={true} width={84} height={84} />
          <Typography2 component="h3" className="pii-hide" variant="subtitleMedium">
            {_t(`#{submitterName} hasn't submitted their assignment yet.`, {
              submitterName: submissionData.data.submitter.name,
            })}
          </Typography2>
          {mailToEmails && (
            <Typography2 component="p" variant="bodyPrimary">
              <Link className="pii-hide" href={`mailto:${mailToEmails}`}>
                <EmailIcon />
                {_t('Email a quick reminder')}
              </Link>
            </Typography2>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoSubmission;
